// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Dzan1","content":"Consent_content__3vSvD","footer":"Consent_footer__38Ovq"};